import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconAI = createSVG({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M17.909 8.653c0.734 0 1.335-0.601 1.335-1.319s-0.601-1.335-1.335-1.335c-0.718 0-1.319 0.618-1.319 1.335s0.601 1.319 1.319 1.319z M13.302 18.001h2.504l-4.106-11.685h-2.854l-4.090 11.685h2.487l0.701-2.103h4.657l0.701 2.103zM8.678 13.744l1.602-4.774 1.602 4.774h-3.205z M16.84 18.001h2.153v-8.346h-2.153v8.346z" }),
});

export { IconAI };
